import { Box, styled } from "@mui/material";

/** OverviewTable cell content wrapper to go with `OverviewTableCellEnd` */
export const OverviewTableCellEndRow = styled(Box)({
  fontSize: 12,
});
